// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"816":"d79df788","961":"791a1c26"}[chunkId] + ".js";
};